// 这个文件是插件的入口文件，它的作用是将插件注册到Vue中，这样就可以在Vue的任何组件中使用插件了。

//import vue文件的name from 路径
import MpegVideoPlayer from "./src/components/MpegtsVideoPlayer/index.vue";

const components = [MpegVideoPlayer];

const install = function (Vue) {
  if (install.installed) return;
  install.installed = true;
  components.forEach(component => Vue.component(component.name, component));
};

if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

// 暴露安装方法和组件
const ChatRobotPlugin = {
  install,
  MpegVideoPlayer,
};

export default ChatRobotPlugin;
export { MpegVideoPlayer };
